export default function(str) {
    if (!str) return null;
    if (!/^\d\d\d+$/.test(str)) return null;

    let code = str.padStart(8, '0')

    if (code.length !== 8) return null;
    return code;
}